export const TOKEN_ADDRESS = "0x0b3eE85E3419ed38A7D00a56010237aA9a712CdC";
export const WALLET_TO_TRACK = "0xc81f7348e1d7B0cC85767165cF0B65365c5eAB3D";
export const ERC20_ABI = ["function balanceOf(address owner) view returns (uint256)"];
export const TOKEN_SUPPLY = 2500000000;
